var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rb-alert py-3 px-5",attrs:{"data-augmented-ui":"both tl-clip br-clip-x"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }